import { render, staticRenderFns } from "./ProjectUpdateTaskAddDialog.vue?vue&type=template&id=2ca3c5f7"
import script from "./ProjectUpdateTaskAddDialog.vue?vue&type=script&lang=js"
export * from "./ProjectUpdateTaskAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports